// @ts-nocheck

import * as proto from '@safeguardproperties/proto/lambda/ml/promptproject/v1/promptproject_v1_pb';
import ServiceClient from './serviceClient';

export class ProjectClient extends ServiceClient {
  constructor(baseUrl: string, debug: boolean) {
    super(baseUrl, debug);
  }

  /**
   * promptprojectapi-specific API method: PostVendorImage
   */
  public async CreatePromptProject(
    request: proto.PromptProjectCreateRequest
  ): Promise<proto.PromptProjectCreateResponse> {
    // @ts-ignore
    return this.Post('create', request, proto.PromptProjectCreateResponse);
  }

  public async Create(
    request: proto.PromptProjectCreateRequest
  ): Promise<proto.PromptProjectCreateResponse> {
    return this.Post('create', request, proto.PromptProjectCreateResponse);
  }

  public async Deactivate(
    request: proto.PromptProjectDeactivateRequest
  ): Promise<proto.PromptProjectDeactivateResponse> {
    return this.Post(
      'deactivate',
      request,
      proto.PromptProjectDeactivateResponse
    );
  }

  public async Activate(
    request: proto.PromptProjectActivateRequest
  ): Promise<proto.PromptProjectActivateResponse> {
    return this.Post('activate', request, proto.PromptProjectActivateResponse);
  }

  public async SetSystemPrompt(
    request: proto.PromptProjectSetSystemPromptRequest
  ): Promise<proto.PromptProjectSetSystemPromptResponse> {
    return this.Post(
      'set_system_prompt',
      request,
      proto.PromptProjectSetSystemPromptResponse
    );
  }

  public async SetOutputPrompt(
    request: proto.PromptProjectSetOutputPromptRequest
  ): Promise<proto.PromptProjectSetOutputPromptResponse> {
    return this.Post(
      'set_output_prompt',
      request,
      proto.PromptProjectSetOutputPromptResponse
    );
  }

  public async GetProject(id: string): Promise<proto.PromptProjectGetResponse> {
    return this.Get(`get/${id}`, proto.PromptProjectGetResponse);
  }

  public async List(): Promise<proto.PromptProjectListResponse> {
    return this.Get('list', proto.PromptProjectListResponse);
  }
}
